import { configure } from 'mobx';
import { TefComs4csMicroFrontend } from './components/tef-coms4cs';
// 29.12.2023 force rebuild
configure({
    isolateGlobalState: true,
});
window.customElements.define('tef-coms4cs', TefComs4csMicroFrontend);
//# sourceMappingURL=index.js.map